export default "__VITE_PUBLIC_ASSET__b8b173e9__"